// extracted by mini-css-extract-plugin
export default {"linkTitle":"TitleWhithLine_linkTitle__WwkDd"};